import type { PayrollReceipt } from '../types';
import { PayrollReceiptItem } from './payroll-receipt-item';

type PayrollReceiptsListProps = {
  receipts: PayrollReceipt[];
  onViewReceipt: (receipt: PayrollReceipt) => void;
  onDownloadReceipt: (receipt: PayrollReceipt) => void;
  downloadingReceiptId: string | null;
};

export function PayrollReceiptsList({
  receipts,
  onViewReceipt,
  onDownloadReceipt,
  downloadingReceiptId,
}: PayrollReceiptsListProps) {
  return (
    <div className="tw-flex tw-flex-col">
      {receipts.map(receipt => (
        <PayrollReceiptItem
          key={receipt.id}
          receipt={receipt}
          onViewReceipt={onViewReceipt}
          onDownloadReceipt={onDownloadReceipt}
          isDownloading={downloadingReceiptId === receipt.id}
        />
      ))}
    </div>
  );
}
